module.exports = __webpack_public_path__ + "img/hexagon.ed482ec3.svg";